export const FETCH_USERS_VIEW_REQUEST = 'FETCH_USERS_VIEW_REQUEST';
export const FETCH_USERS_VIEW_SUCCESS = 'FETCH_USERS_VIEW_SUCCESS';
export const FETCH_USERS_VIEW_FAILURE = 'FETCH_USERS_VIEW_FAILURE';

export const UPDATE_USER__REQUEST = 'UPDATE_USER__REQUEST';
export const UPDATE_USER_SUCCESS = 'UPDATE_USER_SUCCESS';
